import { ConfirmedDeal } from "../../types/empresa";
import { apiSlice } from "../baseQuery";

export const dealApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDealById: builder.query<ConfirmedDeal, { empresaId: number, dealId: number }>({
            query: (request) => `/api/empresas/${request.empresaId}/deals/${request.dealId}`,
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    useGetDealByIdQuery,
} = dealApi;